import { Component, OnInit } from '@angular/core';
import * as $AB from 'jquery';

@Component({
  selector: 'app-purchasehistory',
  templateUrl: './purchasehistory.component.html',
  styleUrls: ['./purchasehistory.component.css']
})
export class PurchasehistoryComponent implements OnInit {

  constructor() { }
p:any;
// len:any;
purchase_history=[
  {'data':'Real Estate Data','icon_img':'../../../assets/image/testicon_realestate.png','img':'../../../assets/image/testimage_realestate.jpg',"domain":"Real Estate"},
  {'data':'Education Data','icon_img':'../../../assets/image/testicon_education.png','img':'../../../assets/image/testimage_education.jpg',"domain":"Education"},
  {'data':'Finance Data','icon_img':'../../../assets/image/Finance.png','img':'../../../assets/image/testimage_finance.jpg',"domain":"Finance"},
  {'data':'Medical Data','icon_img':'../../../assets/image/healthcare2.png','img':'../../../assets/image/testimage_health.jpg',"domain":"HealthCare"},
  {'data':'Energy Data','icon_img':'../../../assets/image/Energy.png','img':'../../../assets/image/testimage_energy.jpg',"domain":"Energy"},
  {'data':'Education Data','icon_img':'../../../assets/image/testicon_education.png','img':'../../../assets/image/testimage_education.jpg',"domain":"Education"},
  {'data':'Finance Data','icon_img':'../../../assets/image/Finance.png','img':'../../../assets/image/testimage_finance.jpg',"domain":"Finance"},
  {'data':'Medical Data','icon_img':'../../../assets/image/healthcare2.png','img':'../../../assets/image/testimage_health.jpg',"domain":"HealthCare"},

]


len=this.purchase_history.length

  ngOnInit(): void {
    
   $(".header-title p").text('Purchase History');
  }

  hovercard(){
    $(".inner-div").css('transition', '5.5s all');
   }
    hovercard2(){
      $(".inner-div").css('transition', '0.5s all')
    }

}

